module.exports = __webpack_public_path__ + "ce5502d42d644c1edba3e139b66e3199.pdf";